import store from './store/store.js'; // Path to your Vuex store
import {AuthError} from './custom-errors.js';
export function encodeQueryString(params) {
    const keys = Object.keys(params)
    return keys.length
        ? "?" + keys
        .map(key => encodeURIComponent(key)
            + "=" + encodeURIComponent(params[key]))
        .join("&")
        : ""
}


//Draws two vertical lines on an SVG element, one at the end of the first data point 
// and another at the start of the last data point.
export function drawVerticalLines(svg, x, height, lineCoordinates) {   
    let firstDataPoint = lineCoordinates[0];
    svg.append("line")
        .attr("x1", x(firstDataPoint.end))
        .attr("x2", x(firstDataPoint.end))
        .attr("y1", 0)
        .attr("y2", height)
        .style("stroke", "grey")
        .style("stroke-width", "1px")
        .style("opacity", 0.5);

    let lastDataPoint = lineCoordinates[lineCoordinates.length - 1];
    svg.append("line")
        .attr("x1", x(lastDataPoint.start))
        .attr("x2", x(lastDataPoint.start))
        .attr("y1", 0)
        .attr("y2", height)
        .style("stroke", "grey")
        .style("stroke-width", "1px")
        .style("opacity", 0.5);
}

/**
 * Validates that specified fields in the given object are non-empty.
 * @param {Object} obj - The object to validate.
 * @param {Array} fields - Array of strings representing the names of the fields to check in the object.
 * @returns {boolean} - Returns true if all specified fields are non-empty, otherwise false.
 */
export function validateRequiredFields(obj) {
    const requiredFields = ['credible_set', 'molecular_trait_id'];

    return requiredFields.every(field => 
        obj[field] !== undefined && 
        obj[field] !== null && 
        obj[field].trim() !== ''  // Add trim() to remove leading/trailing whitespace
    );
}

export async function authFetch(url, options) {
    try {
        let response = await fetch(url, {
            ...options,
            credentials: 'include',
            headers: {
                ...options.headers,
                'Authorization': `Bearer ${store.state.accessToken}`
            }
        });

        // If unauthorized, try to refresh the token
        if (response.status === 401) {
            const refreshSuccess = await store.dispatch('refreshAccessToken');
            if (!refreshSuccess) {
                throw new AuthError('Unauthorized', response);
            }
            // Retry the request with the new token
            response = await fetch(url, {
                ...options,
                credentials: 'include',
                headers: {
                    ...options.headers,
                    'Authorization': `Bearer ${store.state.accessToken}`
                }
            });
            if (response.status === 401) {
                throw new AuthError('Unauthorized', response); // Still unauthorized after refresh
            }
        }

        return response;
    } catch (error) {
        if (error instanceof AuthError) {
            return Promise.reject(new AuthError(error.message, error.response)); // IS this correct way to handle this with AuthError?
        } else {
            // Reformatting error handling
            const newError = new Error('Network or other error: ' + error.message);
            newError.original = error;
            throw newError;
        }
    }
}
